import {
  Home,
  Calendar,
  CalendarClock,
  Clock,
  DollarSign,
  Users,
  User,
  Bell,
} from 'lucide-react';
import type { TherapistDashboardSection } from '../../../types/therapist-dashboard.types';

// Navigation items for sidebar
export const navItems: { id: TherapistDashboardSection; label: string; icon: React.ReactNode }[] = [
  { id: 'overview', label: 'Overview', icon: <Home className="w-5 h-5" /> },
  { id: 'schedule', label: 'Schedule', icon: <Calendar className="w-5 h-5" /> },
  { id: 'appointments', label: 'Appointments', icon: <CalendarClock className="w-5 h-5" /> },
  { id: 'availability', label: 'Availability', icon: <Clock className="w-5 h-5" /> },
  { id: 'earnings', label: 'Earnings', icon: <DollarSign className="w-5 h-5" /> },
  { id: 'clients', label: 'Clients', icon: <Users className="w-5 h-5" /> },
  { id: 'profile', label: 'Profile', icon: <User className="w-5 h-5" /> },
  { id: 'notifications', label: 'Notifications', icon: <Bell className="w-5 h-5" /> },
];

export function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
}

export function formatDate(): string {
  return new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
